import type {Moment} from 'moment-timezone'
import moment from 'moment-timezone'

export const DEFAULT_ELA_MIN_DATE: Moment = moment('2022-07-18')
